import { DI } from '../../../../apps/crossword-maker/src/shared/di';

export const DeleteCrosswordBookWordCategoryUseCase = () => {
    const CrosswordBookRepository = DI.resolve('CrosswordBookRepository');

    return {
        async execute(wordCategoryId: string) {
            return await CrosswordBookRepository.deleteWordCategory(wordCategoryId);
        }
    }
}
